import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errText } from "../../../lib/api";
import { useAuth } from "../../../context/AuthContext";
import { WarningCircle } from "@phosphor-icons/react";
import { AbsenteeRow, OnLeaveRow } from "./AbsentRows";

export const AbsentPanel = ({ date, version, onMarked }) => {
  const { user: me } = useAuth();
  const [data, setData] = useState(null);

  const load = useCallback(() => {
    api.get("/attendance/absent", { params: { date_str: date } }).then((r) => setData(r.data)).catch(() => setData(null));
  }, [date]);
  useEffect(() => { load(); }, [load, version]);

  if (!data) return null;

  const markPresent = async (u, half = false) => {
    try {
      const r = await api.post("/attendance/manual", {
        user_id: u.user_id, date, check_in: "09:00",
        check_out: half ? "13:30" : "18:00", half_day: half,
      });
      toast.success(r.data.message);
      onMarked(date);
    } catch (e) { toast.error(errText(e)); }
  };

  return (
    <div className="bg-white border border-stone-200 rounded-lg" data-testid="absent-panel">
      <div className="p-4 flex items-center gap-2 border-b border-stone-100">
        <WarningCircle size={20} weight="duotone" className={data.absent.length ? "text-red-600" : "text-green-600"} />
        <h3 className="font-heading font-bold text-sm" data-testid="absent-count">
          {data.absent.length === 0 ? "Everyone is accounted for" : `${data.absent.length} employee${data.absent.length > 1 ? "s" : ""} with no attendance`}
        </h3>
        {(data.is_holiday || data.is_weekoff) && (
          <span className="ml-auto px-2.5 py-1 rounded-full bg-blue-50 text-blue-700 text-[11px] font-bold">
            {data.is_holiday ? data.holiday_name : "Sunday week-off"}
          </span>
        )}
      </div>

      {data.absent.length > 0 && (
        <div className="divide-y divide-stone-100" data-testid="absent-list">
          {data.absent.map((u) => (
            <AbsenteeRow key={u.user_id} u={u} onMark={markPresent}
              canQuickMark={!(me?.role === "hr_admin" && u.user_id === me.id)} />
          ))}
        </div>
      )}

      {data.on_leave.length > 0 && (
        <div className="border-t border-stone-100" data-testid="on-leave-list">
          <div className="px-4 pt-3 pb-1 text-[11px] font-bold uppercase tracking-wide text-stone-400">On approved leave ({data.on_leave.length})</div>
          {data.on_leave.map((u) => <OnLeaveRow key={u.user_id} u={u} />)}
        </div>
      )}
    </div>
  );
};
